import { render, staticRenderFns } from "./manuallyAddRequirements.vue?vue&type=template&id=4bebc92a&scoped=true&"
import script from "./manuallyAddRequirements.vue?vue&type=script&lang=js&"
export * from "./manuallyAddRequirements.vue?vue&type=script&lang=js&"
import style0 from "./manuallyAddRequirements.vue?vue&type=style&index=0&id=4bebc92a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bebc92a",
  null
  
)

export default component.exports